import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import Select from 'react-select';



const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class SLMSuburbList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            suburbs: [],
            filter: {},
            showAlert: false,
            showWarning: false,
            errorMessage: "",
            savingNewRecord: false,
            suburb: null,
            postcode: null,
            dataSetPrimaryKey: "suburb_id"
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    

    async componentDidMount() {
        
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        
        try {
            const suburbs = await this.getSuburbs({
                                                        suburb: null,
                                                        postcode: null
                                                    });
            this.setState({ suburbs });
        } catch (e) {
            alert(e);
        }

        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ suburbs: [] });        
    }


    
    async getSuburbs(filter) {
        console.log("Inside getSuburbs() ");
        
        return API.get("colin", "/slmsuburbs", {'queryStringParameters': filter});
      
    }

    

    addRecord = async event => {
        let suburbs = [...this.state.suburbs];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        suburbs.unshift({
            
            name: "",
            sub_region_id: "",
            postcode: "",
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.setState({suburbs});
    }

    

    async saveRecord(record) {
        
        record.last_edited_by= this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                
                return API.post("colin", `/slmsuburbs/new`, {
                    body: record
                });
                
                
            }
        }
    
        return API.put("colin", `/slmsuburbs/${record["suburb_id"]}`, {
            body: record
        });
        
        

       
    }

    

    handleChange = event => {
        console.log("Inside handleChange");
        this.setState({
            [event.target.id]: event.target.value
        });
        
    }

   

    async handleSubmit(event) {
        
        event.preventDefault();
        this.setState({ isLoading: true });
        
        const suburbs = await this.getSuburbs( {
                            suburb: this.state.suburb,
                            state: this.state.postcode
                        });

        this.setState({ suburbs });

        this.setState({ isLoading: false });
                
     }




    validateRecord(record) {

       
        //Check street name not blank
        if ((record.name ||"") === "" || (record.postcode ||"") === "" || (record.sub_region_id ||"") === "") {
            return [false,"Alert!  Suburb, Post Code, State, Sub-Region and Region are all required. The record will NOT be saved until all values have been entered."];
        }
        
       
        return [true,];
    }


    async handleDataSave(data) {
        try {
            return await this.saveRecord(data);


        } catch (e) {
            alert("Error saving");
        }
    }

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let suburbs = [...this.state.suburbs];
        suburbs[cellInfo.index][cellInfo.column.id] = event.target.value;
        suburbs[cellInfo.index].modified = true;
        this.setState({suburbs});
    };
    handleNumberChange = (cellInfo, event) => {
        let suburbs = [...this.state.suburbs];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        suburbs[cellInfo.index][cellInfo.column.id] = Number(val);
        suburbs[cellInfo.index].modified = true;
        this.setState({suburbs});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let suburbs = [...this.state.suburbs];
        suburbs[cellInfo.index][cellInfo.column.id] = event.target.checked;
        suburbs[cellInfo.index].modified = true;
        this.setState({suburbs});
    };

    handleDateChange = (cellInfo, event) => {
        let suburbs = [...this.state.suburbs];
        suburbs[cellInfo.index][cellInfo.column.id] = new Date(event);
        suburbs[cellInfo.index].modified = true;
        this.setState({suburbs});

    }

    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false, showWarning: false });
        let suburbs = [...this.state.suburbs];
        for (var i=0; i<suburbs.length; i++){
            
            
            if (suburbs[i].hasOwnProperty("modified")) {
                if (suburbs[i].modified === true) {
                    console.log("Is modified");
                    const validation = this.validateRecord(suburbs[i]);
                    if (validation[0] === true) {
                        console.log("Is valid");
                        
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (suburbs[i].hasOwnProperty("new_record")) {
                                if (suburbs[i].new_record === true) {
                                    
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(suburbs[i]);
                            if (result.result) {
                                suburbs[i].modified = false;
                                if (suburbs[i].hasOwnProperty("new_record")) {
                                    if (suburbs[i].new_record === true) {

                                        suburbs[i][this.state.dataSetPrimaryKey] = result.id;
                                        suburbs[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    suburbs[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                                this.setState({ savingNewRecord: false });
                            }
                        }
                    

                
            }
            else {
                this.setState({ errorMessage: validation[1] });
                if (suburbs[i].new_record === true) {
                    this.setState({ showWarning: true });
                }
                else{
                    this.setState({ showAlert: true });
                }
                this.setState({ savingNewRecord: false });
                return;
            }
        }
    }
        }   
        if (suburbs[0].hasOwnProperty("sort_order")) {
            suburbs.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        
        this.setState({suburbs});

    }

    handleDropdownChange = (cellInfo, event) => {
        let suburbs = [...this.state.suburbs];
        var indexOfRecord = suburbs.findIndex(i => i.suburb_id === cellInfo.original.suburb_id);
        console.log(event);
        if(event){          
                suburbs[indexOfRecord][cellInfo.column.id] = event.value;
                suburbs[indexOfRecord].sub_region_name = event.label;
                suburbs[indexOfRecord].state_code = event.supplementary_details.state_code;
                suburbs[indexOfRecord].region_name = event.supplementary_details.region_name;
                suburbs[indexOfRecord].modified = true;
                this.setState({suburbs});            
        }
        else{        
            suburbs[indexOfRecord][cellInfo.column.id] = null;
            suburbs[indexOfRecord].sub_region_name = null;
            suburbs[indexOfRecord].state_code = null;
            suburbs[indexOfRecord].sub_region_name = null;
            suburbs[indexOfRecord].modified = true;
            this.setState({suburbs});            
        }
    }

    renderEditable = cellInfo => {
        const cellValue = this.state.suburbs[cellInfo.index][cellInfo.column.id];
        
        if (cellInfo.column.id === "sub_region_id") {
            const cellLabel = this.state.suburbs[cellInfo.index].sub_region_name;
            if (cellValue) {
                return (<div><Select
                    value={{ value: cellValue, label: cellLabel }}
                    onChange={this.handleDropdownChange.bind(null, cellInfo)}
                    options={this.props.subRegionOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                /></div>
                );
            }
            else {
                return (<div><Select
                    value={{ value: null, label: null } }
                    onChange={this.handleDropdownChange.bind(null, cellInfo)}
                    options={this.props.subRegionOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                /></div>
                );
            }
        }

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }
        }
    }

    
    
    
    
      
    
    renderTable(data) {
        const columns = [

            {
                id: 'suburb_id',
                Header: 'ID',
                maxWidth: 150,
                accessor: 'suburb_id'                 
        }
        , {
                id: 'name',
                Header: 'Suburb',            
                accessor: 'name',
                maxWidth: 250,
                Cell: this.renderEditable
                

            }, {
                id: 'postcode',
                Header: 'Post Code',            
                accessor: 'postcode',
                maxWidth: 150,
                Cell: this.renderEditable

            },
            {
                id: 'sub_region_id',
                Header: 'Sub-Region',
                maxWidth: 250,
                accessor: 'sub_region_id',
                Cell: this.renderEditable

            },
            {
                id: 'region_name',
                Header: 'Region',
                maxWidth: 150,
                accessor: 'region_name'

            }
            ,
            {
                id: 'state_code',
                Header: 'State',              
                accessor: 'state_code',
                maxWidth: 150

            }
        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={30}
                    sortable={true}
                />
            )
        }
    }

    
    renderComponent() {
        return (
            <div className="suburbs">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.state.showWarning &&
                                <Alert variant="danger">{this.state.errorMessage}</Alert>
                            }
                <Form onSubmit={this.handleSubmit}>
                    <Form.Row >

                        
                        <Col lg={2}>
                            <Form.Group controlId="suburb">
                                <Form.Control
                                    value={this.state.suburb}
                                    onChange={this.handleChange}
                                    componentClass="input"
                                    type="text"
                                    placeholder="Suburb containing"
                                />
                            </Form.Group>
                            </Col>
                        
                        <Col lg={2}>
                        <Form.Group controlId="postcode">
                                <Form.Control
                                    type="input"
                                    value={this.state.postcode}
                                    onChange={this.handleChange}
                                    placeholder="Post Code equals" />
                            
                            </Form.Group>
                        </Col>                        
                        <Col lg={2}>
                        <Button type="submit" className="float-left">Search</Button>
                        </Col>
                        
                       

                    </Form.Row>
                </Form>
                        
                <Row >
                    <Col className="text-right" >                            
                            <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>
                            
                                
                                
                        </Col>
                    </Row>

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.state.suburbs) : this.renderTable(this.state.suburbs)  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="SuburbList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
